<style lang="less" scoped>
.m-header{
   
        .item{
             text-align: center;
    background: #333;
    margin-bottom: .2rem;
    width: 100%;
            box-sizing: border-box;
            padding:0 .2rem;
            display: flex;
            justify-content: space-between;
            line-height: .8rem;
            font-size: .3rem;
            width: 100%;
            height: .8rem;
            color: #b68c57;
    }
    a{
        font-size: .3rem;
        color: #b68c57;
        text-decoration: none;
    }
    .desc{
        color: #409EFF;
        font-size: .2rem;
    }

    .dialog{
        padding: 1rem;
        .dialog-content{
            padding: 1rem;
            background: #fff;
        }
    }
 
}

</style>

<template>
    <div class="m-header" @dblclick="scrollTop" >
            <div class="item">
                <template>
                    <div v-if="backPath" @click="goback">返回</div>
                    <div class="desc" v-else-if="modifyState" @click="modifyPassword">修改密码</div>
                    <div v-else></div>
                </template>
                
                
                <slot></slot>

                <template>
                    <div v-if="quitState" class="quitBtn" type="primary" @click="logout">退出</div>
                    <div v-if="searchState" @click="goodsSearch">搜索</div>
                <!-- <div  v-if="classify" @click="$router.push('/m/identify/sort')">分类</div> -->
                <div v-else></div>
                </template>
                
                
            </div>
           
            <div class="dialog shadow" v-if="modifyStatus" width="80%">
                <div class="dialog-content">
                    <el-form :model="form">
                        <el-form-item label="">
                        <el-input v-model="form.password" autocomplete="off" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="">
                        <el-input v-model="form.verifyPassword" autocomplete="off" placeholder="请确认密码"></el-input>
                        </el-form-item>
                    </el-form>
                
                    <el-button @click="modifyStatus = false">取 消</el-button>
                    <el-button type="primary" @click="resetPassword">确 定</el-button>
                </div>
            </div>


        </div>
        
</template>
<script>
import api from '../util/api'
import ajax from '../util/ajax'
    export default{
        mixins:[ajax],
        props:{
            backPath:String,
            quitState:Boolean,
            searchState:Boolean,
            classify:Boolean,
            modifyState:Boolean,
        },
        data(){
            return {
                password:'',
                newPassword:'',
                modifyStatus:false,
                form:{
                    password:'',
                    verifyPassword:'',
                },
            }
        },
        created() {
        },
        methods: {
            modifyPassword(){
                this.form.password = ''
                this.form.verifyPassword = ''
                this.modifyStatus = true
            },
            resetPassword() {
            if(this.form.password==this.form.verifyPassword){
                let _p = {}
                _p.account = localStorage.account
                _p.password = this.form.password
                this.patchData(api.resetPassword,_p,(data) => {
                    this.modifyStatus=false
          
                    this.$message({
                      message: '恭喜你，修改成功',
                      type: 'success'
                    })
                }) 
            }else{
                this.$message({
                  message: '请输入相同的密码',
                  type: 'warning'
                })
            }
        },
         
            goback(){
                // this.$router.push(this.backPath)
                this.$router.go(-1);return false;
              
            },
            logout(){
                this.$router.push('/m/login')
                    localStorage.removeItem("token")
                    sessionStorage.removeItem('menu')
                    sessionStorage.removeItem('userRoles')
            },
            goodsSearch(){
                console.log('搜索')
                 this.$emit('listenChildEvent','empty')
                this.$router.push('/m/identify/search')
            },
            scrollTop(){
                document.documentElement.scrollTop = document.body.scrollTop = 0
               
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/header.vue